import { useState } from "react";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import type { EntityFieldComponentProps } from "../entityFieldTypes";

interface Props<T> extends EntityFieldComponentProps<T> {
  ComponentToRender: React.ComponentType<EntityFieldComponentProps<T>>;
}

const EntityFieldTypeWrapper = <T,>({
  value,
  fieldId,
  fieldConfiguration,
  fieldAttributes,
  onChange,
  fieldInputId,
  ComponentToRender,
}: Props<T>) => {
  const [valueState, setValueState] = useState(value);

  const [prevValue, setPrevValue] = useState(value);
  if (value !== prevValue) {
    setPrevValue(value);
    setValueState(value);
  }

  const handleChange = (newValue: T | undefined | null, fieldId: string, validationResult: ValidationResult) => {
    setValueState(newValue);
    onChange(newValue, fieldId, validationResult);
  };

  return (
    <ComponentToRender
      value={valueState}
      fieldId={fieldId}
      fieldConfiguration={fieldConfiguration}
      fieldAttributes={fieldAttributes}
      onChange={handleChange}
      fieldInputId={fieldInputId}
    />
  );
};

export default EntityFieldTypeWrapper;
